import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  cardFooter: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    padding: '0.9375rem 1.875rem',
  },
});
